<template>
  <div id="visa-info-print">
    <el-dialog
      title
      top="50%"
      v-model="showPrintModel"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="print-modal"
      :show-close="false"
    >

      <div class="close" @click="close" v-if="showPrintModel">
        <img src="../../../../assets/imgs/product/icon-close.png" />
      </div>

      <div class="print-pages">
        <div class="print-page" ref="printpage">
          <div class="product-header">
            <div class="product-header-bg"></div>
            <div class="product-title-box">
              <div class="product-title">
                {{ userSetProductName || product.product_name }}
                <div class="edit-title no-print" @click="showEditProductNameModel = true;">
                  <img class="edit-icon" src="../../../../assets/imgs/product-detail/edit-icon.png" alt="">
                  修改标题
                </div>
              </div>
              <div class="product-apply">
                <img class="apply-icon" src="../../../../assets/imgs/product-detail/icon-apply.png" alt="">
                预计办理:&nbsp;<span v-if="product.op_need_days">资料操作&nbsp;{{ product.op_need_days }}&nbsp;工作日&nbsp;+&nbsp;</span>使馆审核预计&nbsp;{{ needDaysComputed }}&nbsp;工作日
                <span class="color-gray" v-if="product.need_return_material">&nbsp;(&nbsp;出签后如需邮寄还需1-2日快递时间&nbsp;)</span>
                <span>&nbsp;，请以领馆实际审核时效为准</span>
              </div>
            </div>
            <div class="product-info-list">
              <div class="product-info-item">
                <div class="item-label">出签率</div>
                <div class="item-value">{{ Math.floor(product.pass_rate / 10) / 10 }}%</div>
              </div>
              <div class="product-info-item">
                <div class="item-label">停留时长</div>
                <div class="item-value" v-if="product.common_info[1].type === 0">{{product.common_info[1].num}}{{product.common_info[1].unit}}</div>
                <div class="item-value" v-else>{{product.common_info[1].unit}}</div>
              </div>
              <div class="product-info-item">
                <div class="item-label">有效期</div>
                <div class="item-value" v-if="product.common_info[0].type === 0">{{product.common_info[0].num }}{{ product.common_info[0].unit}}</div>
                <div class="item-value" v-else>{{product.common_info[0].unit}}</div>
              </div>
              <div class="product-info-item">
                <div class="item-label">入境次数</div>
                <div class="item-value" v-if="product.common_info[2].type === 0">{{product.common_info[2].num}}{{product.common_info[2].unit}}</div>
                <div class="item-value" v-else>{{product.common_info[2].unit}}</div>
              </div>
            </div>
            <div class="flag-box">
              <div class="flag-img" :style="{background: `url(${product.national_flag_img}) no-repeat center / cover`}"></div>
            </div>
          </div>
          <div class="product-body">
            <div class="product-section product-accept-range" v-if="acceptRange">
              <div class="section-header">
                <div class="header-line-1"></div>
                <div class="header-line-2"></div>
                <div class="section-title">受理范围</div>
              </div>
              <div class="section-content">
                <div class="desc-list">
                  <div class="desc-item"
                     v-for="(item, index) in acceptRange.content.split('\n')"
                     :key="index"
                  >{{item}}</div>
                </div>
              </div>
            </div>
            <div class="product-section product-accept-range">
              <div class="section-header">
                <div class="header-line-1"></div>
                <div class="header-line-2"></div>
                <div class="section-title">所需资料</div>
                <div class="tips">
                  <span class="red">*</span>为必备资料
                </div>
              </div>
              <div class="section-content">
                <div class="material-list"
                  v-for="groupItem in materialGroup"
                  :key="groupItem.title"
                >
                  <div class="material-header">
                    <div class="material-title">{{groupItem.title}}({{groupItem.materialList.length}})</div>
                  </div>
                  <div class="material-content">
                    <div class="material-item"
                      v-for="(item, index) in groupItem.materialList"
                      :key="index"
                    >
                      <div class="td td-name">
                        <div class="material-name">
                          <span class="red" v-if="item.is_required">*</span>{{item.name}}
                        </div>
                      </div>
                      <div class="td td-content">
                        <div class="attention-list">
                          <div
                            class="attention-item"
                            v-for="(k, idx) in (item.attention.split('\n'))"
                            v-show="!item.attention.split('\n')[0]==''"
                            :key="'at' + idx"
                          >{{k}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="product-section" v-if="applyInfo">
              <div class="section-header">
                <div class="header-line-1"></div>
                <div class="header-line-2"></div>
                <div class="section-title">办理须知</div>
              </div>
              <div class="section-content">
                <div class="desc-list">
                  <div class="desc-item"
                     v-for="(item, index) in applyInfo.content.split('\n')"
                     :key="index"
                  >
                    {{item}}
                  </div>
                </div>
              </div>
            </div>

            <div class="product-section product-accept-range" v-if="acceptRange">
              <div class="section-header">
                <div class="header-line-1"></div>
                <div class="header-line-2"></div>
                <div class="section-title">温馨提示</div>
              </div>
              <div class="section-content">
                <div class="desc-list">
                  <div class="desc-item">1.办理周期、操作时间、停留时间、签证有效期、签证次数等数据均为预估,实际结果请以领馆审批为准。</div>
                  <div class="desc-item">2.申请人未获得签证前请勿支付机票、酒店、团款等费用,因出签结果造成的预付款经济损失由申请人自行承担。</div>
                </div>
              </div>
            </div>

          </div>
          <div class="product-footer" v-if="showContracts">
            <img src="../../../../assets/imgs/product-detail/peer-info-bg.png" class="footer-bg" />
            <div class="peer-info-box">
              <div class="user-info">
                <div class="user-name">{{ User.name }}</div>
                <div class="user-phone">{{ User.phone_number }}</div>
              </div>
              <div class="peer-info">
                <div class="peer-name">
                  <img class="icon" src="../../../../assets/imgs/product-detail/icon-peer-name.png" alt="">
                  <div class="text">{{User.peer.peer_name}}</div>
                </div>
                <div class="peer-address">
                  <img class="icon" src="../../../../assets/imgs/product-detail/icon-peer-address.png" alt="">
                  <div class="text">{{getAddress(pcds, User.peer)}}</div>
                </div>
              </div>

            </div>
          </div>

        </div>
        <div class="print-bottom" v-if="showPrintModel">
          <div class="bottom-info">
            <div class="block-item">
              <div class="item-label">导出身份：</div>
              <div class="item-value">
                <label class="export-radio">
                  <input type="radio" value="all" v-model="downloadPdfExportType" @change="downloadPdfExportType='all'">
                  <span :class="['radio', downloadPdfExportType === 'all' ? 'active' : '']"></span>
                  全部身份
                </label>
                <label class="export-radio">
                  <input type="radio" value="part" v-model="downloadPdfExportType" @change="downloadPdfExportType='part'">
                  <span :class="['radio', downloadPdfExportType === 'part' ? 'active' : '']"></span>
                  选择
                  <div class="select-box">
                    <el-select v-model="selectIdentity" placeholder="请选择">
                      <el-option :label="identities[item]" :value="index" v-for="(item, index) in currIdentities" :key="index"></el-option>
                    </el-select>
                  </div>
                </label>
              </div>
            </div>
            
            <el-checkbox
              v-if="downloadPdfExportType!=='all'"
              class="show-contracts"
              @change="changeShowContracts"
              v-model="showContracts"
            >底部展示同业联系方式</el-checkbox>
          </div>

          <div class="bottm-btn-list">
            <div class="block-item" v-if="product.offline">
              <div class="item-label">办理方式：</div>
              <div class="select-box">
                <el-select v-model="isOffline" placeholder="请选择" @change="selectIdentity = 0">
                  <el-option label="在线办理" :value="0"></el-option>
                  <el-option label="线下办理" :value="1"></el-option>
                </el-select>
              </div>
            </div>
            <div class="button">
              <div @click="print()">打印</div>
              <div :class="{disabled: downloadPdfLoading}" @click="doPrint()">下载 PDF 版</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 修改标题弹窗 -->
    <el-dialog
      title="修改标题"
      top="50%"
      :close-on-click-modal="false"
      custom-class="edit-product-name-modal"
      v-model="showEditProductNameModel">
      <div class="edit-product-name-box">
        <div class="title">修改标题<span @click="closeEditProductNameModel()">X</span></div>
        <div class="content">
          <textarea maxlength="50" v-model="inputProductName"></textarea>
        </div>
        <div class="button">
          <button @click="closeEditProductNameModel()">取消</button>
          <button @click="setProductName()">确定</button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Http from '@/libs/http';
import User from '../../../../libs/user';
import { generateMaterialList } from '../../services/material-service';
import addressUtils from '../../../../libs/address-utils';
import pcdService from '../../../../services/pcd-service';
import sensorsdata from 'sa-sdk-javascript';
import orderingService from '../../../../services/ordering-service';


export default {
  name: 'visa-info-print',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    product: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    initialIdentityId: {
      type: Number,
      required: true,
      default: 0,
    },
    initialIsOffline: {
      type: [Boolean, Number],
      default: false,
    },
  },
  data() {
    return {
      User,
      showContracts: false,
      showPrintModel: false,

      showEditProductNameModel: false,
      userSetProductName: '',
      inputProductName: '',
      pcds: {},
      isOffline: 0,
      selectIdentity: 0,
      identities: ['在职人员', '自由职业者', '退休人员', '在校学生', '学龄前儿童', '通用身份'],

      downloadPdfLoading: false,
      downloadPdfExportType: 'part', // 全部导出，还是部分身份导出
    };
  },
  computed: {
    // 需要的时间
    needDaysComputed() {
      const { need_days, need_days_longest } = this.product;
      if (need_days >= need_days_longest) {
        return need_days;
      }
      return `${need_days}-${need_days_longest}`;
    },
    // 受理范围list
    acceptRange() {
      return this.product.basic_info.find(item => item.title === '受理范围');
    },
    // 办理须知list
    applyInfo() {
      return this.product.basic_info.find(item => item.title === '办理须知');
    },
    // 当前支持的身份id
    currIdentities() {
      const list = [];
      // 筛选是否是线下
      const allMaterialList = this.isOffline ? this.product.offline_material : this.product.material;
      allMaterialList.forEach((item) => {
        list.push(item.identity_id);
      });
      return list;
    },
    // 被选中的职业id
    identitySelectedId() {
      return this.currIdentities[this.selectIdentity];
    },
    // 当前身份的所有资料
    currMaterial() {
      return generateMaterialList(this.product, this.identitySelectedId, this.isOffline);
    },
    // 当前选中的电子资料
    currElecMaterial() {
      return this.currMaterial.filter(item => item.attr === 0);
    },
    // 当前纸质资料
    currPaperMaterial() {
      return this.currMaterial.filter(item => item.attr === 1);
    },
    // 当前赴馆资料
    currTakeMaterial() {
      return this.currMaterial.filter(item => item.attr === 2);
    },
    // 资料的组，也就是把三个资料合一，用于页面显示
    materialGroup() {
      const arr = [];
      if (this.currElecMaterial.length) {
        arr.push({
          title: '需上传资料',
          materialList: this.currElecMaterial,
        });
      }
      if (this.currPaperMaterial.length) {
        arr.push({
          title: '需邮寄资料',
          materialList: this.currPaperMaterial,
        });
      }
      if (this.currTakeMaterial.length) {
        arr.push({
          title: '赴馆携带资料',
          materialList: this.currTakeMaterial,
        });
      }
      return arr;
    },
  },
  watch: {
    value(newVal) {
      this.showPrintModel = newVal;
      if (newVal) {
        

        // 查询该商品的线上递交的必填资料中包含【邮寄资料】（不包括赴馆）,若是则默认设置线下办理
        this.isOffline = orderingService.isIncludePaperMaterialByRequiredMaterial(this.product) ? 1 : 0;
        // 弹窗显示,初始化赋值, 只要支持线下，就选中线下(旧逻辑)
        // this.isOffline = this.product.offline ? 1 : 0;

        const index = this.currIdentities.indexOf(this.initialIdentityId);
        this.selectIdentity = index > -1 ? index : 0;
        this.$nextTick(() => {
          const scrollEl = document.querySelector('.print-page');
          if (scrollEl) scrollEl.scrollTop = 0;
        });
      }
    },
    product(newVal) {
      if (newVal.visa_product_id) {
        this.getAndSetDefaultCheckPerrInfo();
      }
    },
  },
  created() {
    this.getAndSetDefaultCheckPerrInfo();
    pcdService.getPcd().then(pcds => (this.pcds = pcds)).catch((e) => {
      if (e) console.log(e);
    });
  },
  mounted() {
  },
  methods: {
    // 设置商品名称
    setProductName() {
      if (!this.inputProductName) {
        this.$message({
          message: '请输入标题',
          type: 'warning',
        });
        return;
      }
      this.userSetProductName = this.inputProductName;
      this.showEditProductNameModel = false;
      this.inputProductName = '';
      this.$message({
        message: '修改成功',
        type: 'success',
      });
    },

    // 关闭设置商品名称弹窗
    closeEditProductNameModel() {
      this.inputProductName = '';
      this.showEditProductNameModel = false;
    },

    // 打印
    print() {
      // document.querySelector('.print-page').style = '';
      // 上面的写法在 IE 浏览器会报错，必需要分开设置 style 下的属性
      const target = document.querySelector('.print-page');
      target.style.overflowY = '';
      target.style.maxHeight = '';

      this.$print(this.$refs.printpage);
    },

    // 切换是否显示
    changeShowContracts() {
      localStorage.setItem('showPeerContract', this.showContracts);
    },

    // 下载 PDF
    doPrint() {
      if (this.downloadPdfLoading) return; 
      this.downloadPdfLoading = true;

      sensorsdata.track('ElementClick', {
        page_from: '商品详情页',
        click_content: '下载 PDF 版',
        Identity: this.downloadPdfExportType === 'all' ? '全部身份' : '通用身份',
      });

      // 给后端埋点
      Http.post('/peer_behavior_record_add', {
        visa_product_id: this.product.visa_product_id,
        behavior_type_id: 10011, // 下载商品资料清单/模板
      });

      
      const show_peer = this.showContracts ? 1 : 0;
      Http.post('/product_material_list', {
        online: this.isOffline ? 0 : 1,
        identity_id: this.identitySelectedId,
        visa_product_id: this.product.visa_product_id,
        show_peer: this.downloadPdfExportType === 'all' ? undefined : show_peer,
        product_name: this.userSetProductName || this.product.product_name,
        is_all_identify: this.downloadPdfExportType === 'all' ? 1 : undefined, // 是否导出全部身份
      }).then((res) => {
        window.open(`${res.url}?response-content-type=application/octet-stream`);
        this.downloadPdfLoading = false;
      }).catch(() => {
        this.downloadPdfLoading = false;
      });
    },

    // 设置是否默认显示同业信息
    getAndSetDefaultCheckPerrInfo() {
      const showPeerContractInStorage = localStorage.getItem(
        'showPeerContract',
      );
      if (typeof showPeerContractInStorage !== 'string') {
        localStorage.setItem('showPeerContract', true);
        this.showContracts = true;
      } else {
        this.showContracts = showPeerContractInStorage === 'true';
      }
    },

    // 关闭
    close() {
      this.inputProductName = this.userSetProductName = '';
      this.showPrintModel = false;
      this.$emit('input', false);
    },
    getAddress: addressUtils.getAddress,
    offlineChange() {},
  },
};
</script>

<style lang="less" scoped>
.red{
  color: #FF6464;
}
#visa-info-print {
  .close {
    position: absolute;
    top: 0;
    right: -86px;
    cursor: pointer;
  }
  .print-pages {
    width: 1000px;
    border-radius:2px;
    overflow: hidden;
    .print-page {
      max-height: 780px;
      overflow-y: auto;
      font-size: 14px;

      // 定义滚动条宽高及背景
      &::-webkit-scrollbar {
        width: 8px;
        background-color: #ffffff;
      }

      /*定义滚动条轨道*/
      &::-webkit-scrollbar-track {
        border-radius: 4px;
      }

      // 定义滚动条滑块
      &::-webkit-scrollbar-thumb {
        background-color: rgba(0,0,0,0.2);
        border-radius: 4px;

        &:hover {
          background-color: rgba(0,0,0,0.3);
        }
      }

    }
    .print-bottom {
      height: 144px;
      display: flex;
      flex-direction: column;
      background: #ffffff;
      padding: 24px;
      border-top: 1px solid #DEE2E6;
      .bottom-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .bottm-btn-list {
        display: flex;
        justify-content: space-between;
        margin-top: 8px;
      }

      .block-item {
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #2F333D;
        line-height: 16px;
        .item-label {
          font-weight: 600;
        }
        .item-value {
          display: flex;
          align-items: center;
          .export-radio {
            display: flex;
            align-items: center;
            margin-right: 32px;
            .radio {
              margin-right: 8px;
              border:1px solid #CFCFCF;
              border-radius: 50%;
              width: 18px;
              height: 18px;
              display: inline-block;
              &.active {
                background: #1677FF;
                display: flex;
                align-items: center;
                justify-content: center;
                &::after {
                  content: '';
                  display: inline-block;
                  width: 7px;
                  height: 7px;
                  border-radius: 50%;
                  background: #FFFFFF;
                }
              }
            }
            >input{
              display: none;
            }
            >.select-box {
              margin-left: 8px;
            }
          }
        }
      }

      .select-box{
        width: 110px;
        font-size: 14px;
        margin-right: 16px;
        /deep/ .el-input{
          font-size: 14px;
          color: #5F666E;
          .el-input__icon{
            width: 24px;
            color: #91999F;
            transform: translateY(-50%) rotateZ(180deg) scale(0.7);
            transform-origin: center center;
            right: 4px;
            &.is-reverse{
              transform: translateY(-50%) scale(0.7);
            }
          }
          .el-input__inner{
            padding-right: 16px;
            border-radius: 2px;
            height: 40px;
          }
        }
      }
      .button {
        flex-grow: 1;
        display: flex;
        justify-content: flex-end;
        div {
          width: 180px;
          height: 48px;
          background: #599FFF;
          font-size:18px;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius:4px;
          margin-left: 16px;
          cursor: pointer;
          &.disabled{
            opacity: 0.7;
          }
        }
      }
    }
  }
  .edit-product-name-modal {
    .edit-product-name-box {
      border-radius:4px;
      .title {
        height: 57px;
        border-bottom: 1px solid #f0f0f0;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        font-size: 18px;
        color: #333333;
        font-weight: 600;
        span {
          position: absolute;
          right: 20px;
          top: 20px;
          color: #777777;
          cursor: pointer;
          font-weight: normal;
        }
      }
      .content {
        padding: 20px 40px 0;
        textarea {
          width:280px;
          height:100px;
          background:rgba(255,255,255,1);
          border:1px solid rgba(207,207,207,1);
          border-radius:4px;
          padding: 10px;
          outline: none;
          color: #333;
          font-size: 14px;
          line-height: 20px;
        }
      }
      .button {
        padding: 30px 40px;
        display: flex;
        justify-content: space-between;
        button {
          width: 130px;
          height: 40px;
          font-size: 16px;
          border-radius:4px;
          cursor: pointer;
          &:first-of-type {
            border:1px solid rgba(207,207,207,1);
            background: #ffffff;
            color: #777777;
          }
          &:last-of-type {
            border:1px solid #5E9BE1;
            background: #5E9BE1;
            color: #FFFFFF;
          }
        }
      }
    }
  }
}

// 兼容一下小屏设备
@media screen and (max-height: 880px) {
  #visa-info-print .print-pages .print-page {
    max-height: 700px;
  }
}
@media screen and (max-height: 800px) {
  #visa-info-print .print-pages .print-page {
    max-height: 630px;
  }
}
@media screen and (max-height: 720px) {
  #visa-info-print .print-pages .print-page {
    max-height: 510px;
  }
}
@media screen and (max-height: 620px) {
  #visa-info-print .print-pages .print-page {
    max-height: 420px;
  }
}
</style>

<style lang="less">
#visa-info-print {
  .el-dialog__wrapper {
    background:rgba(0,0,0,0.1);
  }
  .el-dialog {
    transform: translate(-50%, -50%);
    margin: 0;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
  .print-modal {
    width: 1000px;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
  .print-bottom {
    .show-contracts {
      span.el-checkbox__label {
        color: #333333;
      }
    }
  }
  .edit-product-name-modal {
    width: 360px;
    height: 280px;
  }
}
.print-page{
  -webkit-print-color-adjust: exact;
  .product-header{
    background-color: #599FFF;
    position: relative;
    padding: 24px 16px;
    line-height: 1;
    .product-header-bg{
      width: 440px;
      height: 242px;
      background: url(../../../../assets/imgs/product-detail/print-masterial-bg.png) no-repeat center / 100% 100%;
      position: absolute;
      right: 0;
      top: 0;
    }
    .product-title-box{
      padding-top: 16px;
      position: relative;
      z-index: 1;
      .product-title{
        font-size: 28px;
        color: #fff;
        font-weight: 600;
        line-height: 36px;
        margin-bottom: 20px;
        .edit-title{
          margin-left: 12px;
          line-height: 36px;
          display: inline-flex;
          align-items: center;
          font-size: 20px;
          vertical-align: top;
          cursor: pointer;
          .edit-icon{
            width: 24px;
            height: 24px;
            margin-right: 4px;
          }
        }
      }
      .product-apply{
        font-size: 18px;
        line-height: 1.5;
        color: #fff;
        padding-left: 15px;
        .apply-icon{
          width: 16px;
          margin-right: 4px;
          vertical-align: text-top;
        }
      }
    }
    .product-info-list{
      margin-top: 48px;
      display: flex;
      padding: 0 16px;
      .product-info-item{
        margin-right: 48px;
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        .item-label{
          color: #fff;
          font-size: 16px;
        }
        .item-value{
          font-size: 24px;
          line-height: 32px;
          color: #fff;
          margin-top: 8px;
        }
      }
    }
    .flag-box{
      background:linear-gradient(180deg,rgba(255,255,255,1) 0%,rgba(245,249,255,1) 100%);
      position: absolute;
      right: 60px;
      bottom: -50px;
      width: 100px;
      height: 100px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0;
      z-index: 10;
      .flag-img{
        width: 90px;
        height: 90px;
        border-radius: 50%;
      }
    }

  }
  .product-body{
    padding: 24px 0 0 0;
    .product-section{
      .section-header{
        position: relative;
        height: 40px;
        background:linear-gradient(270deg,rgba(255,255,255,1) 0%,rgba(242,247,255,1) 100%);
        color: #2F333D;
        font-size: 20px;
        display: flex;
        align-items: center;
        font-weight: 600;
        padding: 0 32px;
        .header-line-1{
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 6px;
          background-color: #599FFF;
        }
        .header-line-2{
          position: absolute;
          left: 6px;
          top: 0;
          height: 100%;
          width: 6px;
          background:#599FFF;
          opacity:0.2;
        }
        .tips{
          margin-left: 12px;
          font-size: 16px;
          color: #5F666E;
          font-weight: 400;
        }
      }
      .section-content{
        padding:  24px 32px;
        .desc-list{
          padding-left: 10px;
          .desc-item{
            color: #2F333D;
            font-size: 16px;
            position: relative;
            line-height: 28px;
            .dot{
              width: 4px;
              height: 4px;
              background-color: #2F333D;
              position: absolute;
              border-radius: 50% 50%;
              left: -10px;
              top: 12px;
            }
          }
        }

        .material-list{
          background-origin: padding-box;
          border-top:  1px solid #DEE2E6;
          border-left: 1px solid #DEE2E6;
          border-bottom: 1px solid #DEE2E6;
          margin-bottom: 16px;
          &:last-child{
            margin-bottom: 0;
          }
          .material-header{
            height: 48px;
            background-color: #FAFBFC;
            display: flex;
            align-items: center;
            padding: 0 16px;
            .material-title{
              font-size: 16px;
              color: #2F333D;
              font-weight: 600;
            }
          }
          .material-content{
            .material-item{
              display: flex;
              .td{
                border-right:  1px solid #DEE2E6;
                border-top: 1px solid #DEE2E6;
                display: flex;
                align-items: center;
              }
              .td-name{
                flex-shrink: 0;
                width: 208px;
                font-size: 18px;
                color: #2F333D;
                line-height: 24px;
                font-weight: 600;
                padding: 12px 24px;
                .material-name{
                  display: flex;
                }
              }
              .td-content{
                flex-grow: 1;
                overflow: hidden;
                padding: 12px 24px;
                .attention-list{
                  padding-left: 10px;
                  .attention-item{
                    position: relative;
                    color: #2F333D;
                    font-size: 16px;
                    line-height: 28px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .product-footer{
    margin-top: 16px;
    width: 100%;
    background:linear-gradient(270deg,rgba(248,250,255,1) 0%,rgba(237,243,255,1) 100%);
    padding: 0 16px 0 120px;
    position: relative;
    .footer-bg{
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      z-index: 1;
    }
    .peer-info-box{
      position: relative;
      z-index: 2;
      display: flex;
      .user-info{
        padding-top: 24px;
        width: 125px;
        color: #2F333D;
        font-size: 18px;
        line-height: 1;
        margin-right: 100px;
        .user-name{
          margin-bottom: 11px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .user-phone{
          font-size: 16px;
        }
      }
      .peer-info{
        flex-grow: 1;
        display: flex;
        flex-wrap: wrap;
        padding-top: 50px;
        .peer-name, .peer-address{
          display: flex;
          line-height: 1;
          margin-bottom: 10px;
          .icon{
            flex-shrink: 0;
            width: 16px;
            height: 16px;
            margin-right: 4px;
            margin-top: 2px;
          }
          .text{
            color: #5F666E;
            font-size: 14px;
            line-height: 20px;
          }
        }
        .peer-name{
          margin-right: 24px;
        }
      }

    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/product/product-info/components/visa-info-print.vue